import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, switchMap, tap } from 'rxjs/operators';
import { SearchPoiResult } from '../models';
import { AzureMapsAuthService } from './azure-maps-auth.service';


/**
* This services handles the hospital/company autocomplete search.
*/
@Injectable({ providedIn: 'root' })
export class MapsService {

	private readonly http = inject(HttpClient);
	private readonly azureMapAuthSrv = inject(AzureMapsAuthService);

	private readonly COMPANY_CATEGORY_SET = '9352';
	private readonly HOSPITAL_CATEGORY_SET = '7321';
	private readonly SEARCH_POI_URL = 'https://atlas.microsoft.com/search/poi/json';


	/**
	* Search for the hospitals on text changes.
	*/
	searchHospitals = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(200),
			distinctUntilChanged(),
			filter(x => x.length > 2),
			switchMap(x => this.searchPOI(x, this.HOSPITAL_CATEGORY_SET)),
			tap(x => console.log(x))
		);

	/**
	* Search for the companies on text changes.
	*/
	searchCompanies = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(200),
			distinctUntilChanged(),
			filter(x => x.length > 2),
			switchMap(x => this.searchPOI(x, this.COMPANY_CATEGORY_SET)),
			tap(x => console.log(x))
		);


	private searchPOI(query: string, categorySet: string): Observable<SearchPoiResult[]> {
		const sasToken = this.azureMapAuthSrv.getCurrentToken();
		if (!sasToken) return of([]);
		return this.getSearchPOI(query, categorySet, sasToken);
	}

	private getSearchPOI(query: string, categorySet: string, sasToken: string): Observable<SearchPoiResult[]> {
		const headers = new HttpHeaders({ 'Authorization': `jwt-sas ${sasToken}` });
		const params = new HttpParams()
			.set('api-version', '1.0')
			.set('typeahead', 'true')
			.set('query', query)
			.set('categorySet', categorySet)
			.set('limit', '5');
		return this.http.get<any>(this.SEARCH_POI_URL, { headers, params }).pipe(
			map(res => res.results || [])
		);
	}

}
